import React from "react";
import { Link } from "@mui/material";
import { spaLink } from "../../utils/spaLink";

interface SpaLinkProps {
  isStaff: boolean;
  spaV2Id?: string | null;
  spaGuid?: string | null;
  /** The visible text (spa GUID or serial). No label → renders "—" with no link. */
  label?: React.ReactNode;
  /** Link styling; redesigned tables pass their own (e.g. dt-guid, dt-serial) */
  className?: string;
}

/**
 * Renders a spa identifier (GUID or serial) as a new-tab link to the spa — the v2 in-app page
 * for a migrated tub, or the legacy portal for a v1 tub (see utils/spaLink). Falls back to
 * plain text / "—" when there's no label or no resolvable target.
 */
const SpaLink: React.FC<SpaLinkProps> = ({ isStaff, spaV2Id, spaGuid, label, className }) => {
  const href = label ? spaLink(isStaff, spaV2Id, spaGuid) : null;

  if (!href) {
    return <>{label ?? "—"}</>;
  }

  if (className) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={className}>{label}</a>;
  }

  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" className="clickable-icon">
      {label}
    </Link>
  );
};

export default SpaLink;
